import { RemoteVerifyInternshipResponsibleCpf } from 'data/usecases';
import { makeApiUrlInternshipResponsibleCpf } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteVerifyInternshipResponsibleCpf =
  (): RemoteVerifyInternshipResponsibleCpf => {
    return new RemoteVerifyInternshipResponsibleCpf(
      makeApiUrlInternshipResponsibleCpf(),
      makeAxiosHttpClient(),
    );
  };
